import { config } from 'src/config/config';
// File: cgp-user-profile-dialog-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile component.
// Other Contributors:

import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { forkJoin } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { TprecmUserProfile } from 'src/modules/api/tprecm-api.interface';
import { UserService } from 'src/modules/user.service';
import { BaseHttpService } from '../base-http/base-http.service';
import { getEnv } from 'src/modules/utility';

@Component({
    selector: "cgp-app-bar-dialog",
    templateUrl: "./cgp-user-profile-dialog.template.html"
})
export class CgpUserProfileDialogComponent implements OnInit {

    private roles = [];

    @Input() size;
    @Input() title;
    @Input() closeLabel;

    constructor(
        public dialogRef: MatDialogRef<CgpUserProfileDialogComponent>,
        private readonly user: UserService,
        private readonly http: BaseHttpService
    ) { }

    ngOnInit(): void {
        this.http.get(`${config.tprecmApiBaseUrl[getEnv()]}maint/criteria/role`)
            .pipe(take(1))
            .subscribe((response) => this.roles = response);
    }

    getUserProfile() {
        return this.user.UserProfile;
    }

    getUserRole() {
        return this.user.userProfile
            .pipe(
                map(profile => this.roles.find(role => role.id === profile.userRoleId)),
                filter(Boolean),
                map((role: any) => role.userRole)
            );
    }
}
